export const DATE_PICKER = 'date-range-picker';
export const DATE_PICKER_LABEL_START = 'date-picker-label-start';
export const DATE_PICKER_INPUT_START = 'date-picker-input-start';
export const DATE_PICKER_NO_LABEL = 'date-picker-no-label';
export const DATE_PICKER_LABEL_END = 'date-picker-label-end';
export const DATE_PICKER_INPUT_END = 'date-picker-input-end';
